<div class="card card-shadow">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">Review Auto-Payroll</h3>
    <ng-container
      *ngIf="payrollStartConfig.Unsupported?.length; then no_functionality; else payroll">
    </ng-container>
    <ng-template #no_functionality>
      We are not quite ready for payrolls with
      {{ payrollStartConfig.Unsupported[0] }}. We will let you know when new functionality is
      available. For now, please enter this client's payroll in the APS system.
    </ng-template>
    <ng-template #payroll>
      <div>
        Auto-payrolls run completely hands-free. If you would like to make temporary changes before
        the next process date, you can review and update here. Scheduled to process
        <strong>on {{ dateUntilNextPayrollSubmission }}</strong>
      </div>
      <div *ngIf="activePayroll">
        <h6 class="cp-green fw-bold mb-0">
          {{
            activePayroll?.IsAutomaticSkipped
              ? 'Automatic processing skipped for this period'
              : 'Entry in
          progress'
          }}
        </h6>
        <small class="cp-green">
          Last edit by {{ activePayroll.LastEditBy }} on
          {{ activePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
        </small>
      </div>
      <div *ngIf="activePayroll && isPayDateInvalid">
        <h5>
          This payroll is overdue and cannot be resumed. Cancel the payroll to proceed. If you have
          any questions, contact your Payroll Specialist.
        </h5>
      </div>
    </ng-template>
    <div class="row mt-auto">
      <div class="d-flex justify-content-end align-items-center mt-4">
        <button
          *ngIf="!activePayroll?.IsAutomaticSkipped"
          type="button"
          (click)="skipAutomaticPay()"
          class="btn btn-secondary me-2">
          Skip Automatic
        </button>
        <button
          *ngIf="!isPayDateInvalid"
          type="button"
          [disabled]="isSubmitDisabled"
          class="btn btn-primary"
          (click)="navigatePayroll()">
          Review Payroll
        </button>
      </div>
    </div>
  </div>
</div>
